// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customTabs .ant-tabs > .ant-tabs-nav {
  border-bottom: 1px solid #DEDEDE;
}

.tab_container .ant-tabs.ant-tabs-top {
  padding: 10px 30px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Tabs/Tabs.scss"],"names":[],"mappings":"AACI;EACI,gCAAA;AAAR;;AAKI;EACI,kBAAA;AAFR","sourcesContent":[".customTabs {\n    .ant-tabs > .ant-tabs-nav {\n        border-bottom: 1px solid #DEDEDE;\n    }\n}\n\n.tab_container {\n    .ant-tabs.ant-tabs-top {\n        padding: 10px 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
